import React, { Component, Fragment } from "react";
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert, Spinner, CardBody } from "reactstrap";
import { Helmet } from "react-helmet";
import axios from "axios";
import { Card, CardMedia } from '@mui/material'
import Table from "./../../components/general/Table/Table";
import ClientForm from "./../../components/page/clientUser/ClientUserForm/ClientUserForm";
import EditUserModal from "./../../components/page/clientUser/EditUserModal/EditUserModal";
import { trackPromise } from "react-promise-tracker";
import DataTable from "../../components/general/DataTable/DataTable";
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import KeyIcon from '@mui/icons-material/Key';
import CustomPopover from "../../components/general/DataTable/CustomPopover";

import classes from '../../components/page/placeholderTrucks/EditPlaceholderModal/EditPlaceholderModal.module.scss'
import { boxiPrimary } from "../../assets/style/colors";


const ThumbnailColumn = ({ imageUrl }) => {
  if (imageUrl === '') {
    return (
      <div 
      style={{ display: 'flex',
       justifyContent: 'center',
        alignItems: 'center', 
        height: '75px', margin: '0px 20px',
         width: '100px',
        color: '#000000de' 
      }}>
        <div style={{ width: '100%', height: '1px', background: '#000' }}></div>
      </div>
    );
  }

  return (
    <Card style={{ margin: '10px 0' }}>
      <Card style={{ height: '75px', width: '75px' }}>
        <CardMedia
          component="img"
          alt="Thumbnail"
          image={imageUrl}
          style={{ height: '100%', width: '100%', objectFit: 'cover' }}
        />
      </Card>
    </Card>
  );
};
class ClientUser extends Component {
  state = {
    tableData: [],
    tableHeaders: [],
    showEditModal: false,
    clientData: null,
    isLoading: false,
    isClientUserDeleteModalOpen: false,
    clientUserToDelete: null,
    isDeleting: false,

    toastHeader: "",
    toastBody: "",
    isToastOpen: false,

    clientUsersRows: [],
    clientUsersColumns: [
      { width: 20, field: 'id', headerName: '#', sortable: false },
      { flex: .5, field: 'userProfileUrl', headerName: '', sortable: false, 
      renderCell: (params) => {
        return (
          <ThumbnailColumn imageUrl={params.row.userProfileUrl} />
        );
      }
      },
      { flex: 1, field: 'user_name', headerName: 'Client Name' },
      { flex: 1, field: 'email', headerName: 'Client Email' },
      { flex: 1, field: 'company', headerName: 'Client Company' },
      { flex: 1, field: 'campaign', headerName: 'Client Campaigns', renderCell: (params) => {
        return (
          <CustomPopover data={params.row.campaign} />
        )
      } },
      { width: 30, field: 'btn', headerName: '', sortable: false, 
        renderCell: (params) => {
          return (
            <EditIcon onClick={() => this.toggleModal(params.row)} style={{ color: boxiPrimary, cursor: 'pointer' }}>
            </EditIcon>
          );
        }
      },
      { width: 30, field: 'btn1', headerName: '', sortable: false, 
        renderCell: (params) => {
          return (
            <DeleteForeverIcon onClick={() => this.toggleUserDeleteModal(params.row)} color="error" style={{ cursor: 'pointer' }}>
            </DeleteForeverIcon>
          );
        }
      },
      { width: 30, field: 'btn2', headerName: '', sortable: false, 
        renderCell: (params) => {
          return (
            <KeyIcon onClick={() => this.props.history.push(`/dashboard/admin/advertise/user/${params.row.user_id}/credential`)} color="primary" style={{ cursor: 'pointer' }}>
            </KeyIcon>
          );
        }
      },
    ],
    clientUsersParams: {
      sortOrder: 'asc',
      sortBy: 'user_name',
      page: 0,
      pageSize: 10,
      search: null
    },
    isClientUsersLoading: false,
    totalClientUsers: 0
  };

  toggleModal = (data) => {
    if (this.state.showEditModal) {
      this.setState({
        showEditModal: false,
        clientData: null
      });
    } else {
      this.setState({
        showEditModal: true,
        clientData: data
      });
    }
  };

  getClientUsers = (sortOrder = 'asc', sortBy = 'user_name', page = 0, pageSize = 10, search = null) => {
    const params = {
      sortOrder, 
      sortBy, 
      page, 
      pageSize,
      search
    }

    this.setState({
      clientUsersParams: params,
      isClientUsersLoading: true
    })

    axios.get(`${process.env.REACT_APP_API_HOST}/user/client-users`, {params}).then((res) => {
      if (res.status === 200) {
        console.log(res.data);
        console.log(this.state.isClientUsersLoading);
        const rows = [];
        res.data.clients.map((client, index) => {
          rows.push({
            id: (page * pageSize) + index + 1,
            user_id: client.user_id, 
            user_name: client.user_name, 
            email: client.email, 
            company: client.company, 
            campaign: client.campaign ? client.campaign + '' : null,
            userProfileUrl: client.user_profile_image ? client.user_profile_image : '' 
          })
        });
        this.setState({
          clientUsersRows: rows,
          isClientUsersLoading: false,
          totalClientUsers: res.data.rowCount
        })
      }
    })
  }

  toggleUserDeleteModal = (client) => {
    console.log('toggle called');
    this.setState({
      clientUserToDelete: client
    }, () => {
      this.setState({
        isClientUserDeleteModalOpen: !this.state.isClientUserDeleteModalOpen
      })
    })
  }

  deleteClientUser = async (e) => {
    e.preventDefault()
    try {
      this.setState({
        isDeleting: true
      })
      console.log(this.state.clientUserToDelete.user_id);
      let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/user/${this.state.clientUserToDelete.user_id}`, { withCredentials: true });
      if (res.status === 200) { 
        this.setState({
          isDeleting: false,
          toastHeader: 'Success',
          toastBody: `The account for ${this.state.clientUserToDelete.user_name} was deleted.`,
          isToastOpen: true,
          isClientUserDeleteModalOpen: false,
          clientUserToDelete: null,
        }, () => {
          this.getClientUsers(this.state.clientUsersParams.sortOrder, this.state.clientUsersParams.sortBy, this.state.clientUsersParams.page, this.state.clientUsersParams.pageSize, this.state.clientUsersParams.search);
          setTimeout(() => {
            this.setState({
              isToastOpen: false
            })
          }, 3000);
        })
      }
    } catch (err) {
      console.log(err);
      this.setState({
        toastHeader: 'Failure',
        toastBody: 'There was a problem deleting this client user!',
        isToastOpen: true
      })
      setTimeout(() => {
        this.setState({
          isToastOpen: false
        })
      }, 3000);
    }
  }

  // getUserData = () => {
  //   this.setState({
  //     isLoading: true
  //   })
  //   trackPromise(axios
  //     .get(`${process.env.REACT_APP_API_HOST}/user/client`, {withCredentials: true})
  //     .then((response) => {
  //       let headers = ["id", "Name", "Company", "Campaigns", "Email"];
  //       let clients = response.data.clients.map((client, index) => {
  //         let campaigns = client.campaigns.map((campaign) => campaign.name).join("; ");
  //         return [client.user_id, client.name, client.company, campaigns, client.email];
  //       });
  //       // sort clients by name alphabetically ascending
  //       clients = clients.sort((a, b) => {
  //         let first = a[1].toUpperCase();
  //         let second = b[1].toUpperCase();
  //         return (first === "") - (second === "") || +(first > second) || -(first < second);
  //       });
  //       this.setState({
  //         tableHeaders: headers,
  //         tableData: clients,
  //         isLoading: false
  //       });
  //     })
  //     .catch((err) => {
  //       this.setState({
  //         isLoading: false
  //       })
  //       console.log(err);
  //     })
  //   );

  // };

  componentDidMount() {
    this.getClientUsers();
  }

  render() {
    let clientUsersTableButtons = [
      {
        display: "Edit",
        onClickHandler: (index) => {
          this.toggleModal(this.state.tableData[index]);
        }
      },
      {
        display: "Delete",
        onClickHandler: (index, id) => {
          if (
            window.confirm(
              `Are you sure you want to delete the account for ${this.state.tableData[index][1]}?\nThis action is irreversible.`
            )
          ) {
            axios
              .delete(`${process.env.REACT_APP_API_HOST}/user/${id}`, {withCredentials: true})
              .then((res) => {
                if (res.status === 200) {
                  alert(`The account for ${this.state.tableData[index][1]} was deleted.`);
                  this.getUserData();
                }
              })
              .catch((err) => console.log(err));
          }
        }
      },
      {
        display: "Credentials",
        // path: "/dashboard/admin/advertise/campaign/edit"
        onClickHandler: (index, id) => {
          this.props.history.push(`/dashboard/admin/advertise/user/${id}/credential`);
        }
      }
    ];
    return (
      <Fragment>
        {this.state.toastHeader === 'Success' && this.state.isToastOpen && 
          <Alert className={classes.alertMsg}>
            {this.state.toastBody}
          </Alert>
        }
        {this.state.toastHeader === 'Failure' && this.state.isToastOpen && 
          <Alert className={classes.alertMsg} color="danger">
            {this.state.toastBody}
          </Alert>
        }
        <Helmet>
          <title>Boxi Admin | Client Users</title>
        </Helmet>
        <Row className="mb-4">
          <Col lg="12" className="mb-4">
            <ClientForm refresh={this.getClientUsers} />
          </Col>
          <Col lg="12">
            {/* <Table
              id="client-users-table"
              title="Client Users"
              buttons={clientUsersTableButtons}
              headers={this.state.tableHeaders}
              data={this.state.tableData}
              isLoading={this.state.isLoading}
              loadingText="Loading Client Users..."
            ></Table> */}
            <DataTable
              title="Client Users"
              rows={this.state.clientUsersRows}
              columns={this.state.clientUsersColumns}
              fetchData={this.getClientUsers}
              params={this.state.clientUsersParams}
              isLoading={this.state.isClientUsersLoading}
              rowCount={this.state.totalClientUsers}
            />
          </Col>
        </Row>
        <EditUserModal show={this.state.showEditModal} toggleModal={this.toggleModal} data={this.state.clientData} />

        <Modal className={classes.modalDialog} isOpen={this.state.isClientUserDeleteModalOpen}>
          <ModalHeader>Delete Client User?</ModalHeader>
          <ModalBody>
            Are you sure you want to delete this Client User?
            <br />
            This Action is irreversible!
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.deleteClientUser}>
              {this.state.isDeleting ? 
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Spinner
                      style={{ width: "1.2rem", height: "1.2rem" }}
                      type="border"
                      color="light"
                      className="spinner-border-sm"
                    />
                </div>
                :
                <span>Delete</span>
              }
            </Button>
            <Button color="secondary" onClick={() => this.toggleUserDeleteModal(null)}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

export default ClientUser;
